const Svg = ({ width = 31 }: { width?: number } = {}) => (
  <svg
    width={width}
    height={(width / 31) * 60}
    viewBox="0 0 31 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3_807)">
      <path
        d="M0.849641 0.845459L30.1504 30.0028L0.849641 59.1545"
        stroke="#808080"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3_807">
        <rect
          width="31"
          height="60"
          fill="white"
          transform="matrix(-1 0 0 1 31 0)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default Svg;
